<template>
    <ValidationObserver class="row" ref="form">
        <div class="col-lg-12 mb-4">
            <div class="box">
                <div class="box-offset">
                    <div class="box-ttl-wrap">
                        <div class="box-ttl">
                            Bookable appointment schedule
                        </div>
                    </div>
                    <div class="mt-3">
                        <div class="row">

                            <ValidationProvider
                                class="col-md-4"
                                rules="required"
                                v-slot="{ errors }"
                                name="Duration"
                            >
                                <div class="form-group form-group-1">
                                    <label for="" class="form-label">Appointment Duration (minutes)</label>
                                    <input type="number" min="1" class="form-control" v-model="form.duration">
                                    <FormError :error="errors[0]" name="Duration"></FormError>
                                </div>
                            </ValidationProvider>

                        </div>
                        <div class="" style="width: max-content; max-width: 100%">
                            <div class="accordion ">
                                <div class="accordion--card">
                                    <button class="accordion--btn accordion--btn-small" data-toggle="collapse" data-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                                        Repeat Weekly
                                    </button>
                                    <div id="collapse2" class="collapse show" aria-labelledby="headingTwo" >
                                        <div class="mt-3">
                                            <DayAvailability
                                                v-for="(day, index) in form.schedule"
                                                :day="day"
                                                :key="index"
                                                @data-changed="updateForm"
                                            ></DayAvailability>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="wrap-border-top">
                            <div class="accordion ">
                                <div class="accordion--card">
                                    <div id="k2" class="collapse show" aria-labelledby="kTwo" >
                                        <div class="mt-3">
                                            <div>
                                                <p>Maximum time in advance that an appointment can be booked</p>
                                                <div class="d-flex align-items-center">
                                                    <ValidationProvider
                                                        class="form-group form-group-1 mb-0 ml-3 w-80"
                                                        rules="required"
                                                        v-slot="{ errors }"
                                                        name="maximum time"
                                                    >
                                                        <input
                                                            type="number"
                                                            min="1"
                                                            class="form-control"
                                                            v-model="form.maximum_time"
                                                        >
                                                        <FormError :error="errors[0]" name="maximum time"></FormError>
                                                    </ValidationProvider>
                                                    <div class="ml-3">Days</div>
                                                </div>
                                            </div>
                                            <div class="mt-4">
                                                <p>Minimum time before the appointment can be booked</p>
                                                <ValidationProvider
                                                    class="d-flex align-items-center"
                                                    rules="required"
                                                    v-slot="{ errors }"
                                                    name="min time"
                                                >
                                                    <div class="form-group form-group-1 mb-0 ml-3 w-80" >
                                                        <input
                                                            type="number"
                                                            min="1"
                                                            class="form-control"
                                                            v-model="form.minimum_time"
                                                        >
                                                        <FormError :error="errors[0]" name="min time"></FormError>
                                                    </div>
                                                    <div class="ml-3">Hours</div>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-3">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">Notes</label>
                                        <textarea
                                            type="text"
                                            class="form-control"
                                            v-model="form.notes"
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="wrap-border-top">
                            <div class="accordion ">
                                <div class="accordion--card">
                                    <button class="accordion--btn accordion--btn-small" data-toggle="collapse" data-target="#k4" aria-expanded="false" aria-controls="k4">
                                        Booked appointment settings
                                    </button>
                                    <div id="k4" class="collapse show" aria-labelledby="kfr" >
                                        <div class="mt-3">
                                            <p>Manage the booked appointment that will appear on your calendar</p>
                                            <h5>Buffer time</h5>
                                            <p>Add time between appointment slots</p>
                                            <div class="d-flex align-items-center mb-3">

                                                <ValidationProvider
                                                    class="form-group form-group-1 mb-0 ml-3 w-80"
                                                    rules="required"
                                                    v-slot="{ errors }"
                                                    name="buffer time"
                                                >
                                                    <input
                                                        type="number"
                                                        min="1"
                                                        class="form-control"
                                                        v-model="form.buffer_time"
                                                    >
                                                    <FormError :error="errors[0]" name="buffer time"></FormError>
                                                </ValidationProvider>

                                                <ValidationProvider
                                                    class="form-group form-group-1 mb-0 ml-3 w-80"
                                                    rules="required"
                                                    v-slot="{ errors }"
                                                    name="buffer time units"
                                                >
                                                    <select class="custom-select" v-model="form.buffer_time_units" >
                                                        <option value="minutes">Minutes</option>
                                                        <option value="hours">Hours</option>
                                                    </select>
                                                    <FormError :error="errors[0]" name="buffer time units"></FormError>
                                                </ValidationProvider>

                                            </div>
                                            <h5>Maximum bookings per day</h5>
                                            <p>Limit how many booked appointments to accept in a single day</p>

                                            <ValidationProvider
                                                class="d-flex align-items-center mb-3"
                                                rules="required"
                                                v-slot="{ errors }"
                                                name="max bookings"
                                            >
                                                <div class="form-group form-group-1 mb-0 ml-3 w-80">
                                                    <input
                                                        type="number"
                                                        min="1"
                                                        class="form-control"
                                                        v-model="form.maximum_bookings"
                                                    >
                                                    <FormError :error="errors[0]" name="max bookings"></FormError>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="wrap-border-top">
                            <div class="btns-wrap">
                                <a href="/master-admin/calendar" class="btn btn--outline-primary w-100 w-sm-auto">Cancel</a>
                                <button class="btn btn--secondary w-100 w-sm-auto" @click="validate">Save</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
import DayAvailability from "./DayAvailability.vue";
import DayItem from "../../../TimeSheet/resources/js/DayItem.vue";
import CalendarService from "./services/CalendarService";

export default {
    name: "WorkdaySettings",
    props: {
        appointmentInfo: {
            type: Object,
            required: true
        }
    },
    components: {DayItem, DayAvailability},
    data() {
        return {
            week: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            form: {
                duration: null,
                schedule: [],
                maximum_time: null,
                minimum_time: null,
                notes: null,
                buffer_time: null,
                buffer_time_units: 'minutes',
                maximum_bookings: null,
            }
        }
    },
    mounted() {
        this.generateWeek()
        this.setData()
    },
    methods: {
        async validate() {
            const valid = await this.$refs.form.validate();

            if (!valid) {
                this.$showValidationErrorMessage();
                return;
            }

            await this.sendAppointmentSettings()
        },
        setData() {
            for (const key of Object.keys(this.appointmentInfo)) {
                if (this.form.hasOwnProperty(key)) {
                    this.form[key] = this.appointmentInfo[key];
                }
            }
        },
        async sendAppointmentSettings() {
            this.$showLoadingMessage()
            try {
                await CalendarService.updateSettings(this.form)
                this.$showSuccessMessage('Workday settings has been updated')
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('Workday settings was not updated')
            }
        },
        generateWeek() {
            this.form.schedule = [];
            this.week.forEach(day => {
                this.form.schedule.push({
                    index: day,
                    start: null,
                    end: null,
                    day: day,
                    isUnavailable: true,
                });
            });
        },

        updateForm(result) {
            const index = this.form.schedule.findIndex(day => day.index === result.index);
            if (index !== -1) {
                this.form.schedule.splice(index, 1, result);
            }
        },
    },
}
</script>

<style scoped>

</style>
